import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const eliminarPersonaService = async ({ token, id, callbacks }) => {
    const response = await connection({ method: 'DELETE', url: `${ENTITY_URL.PERSONA.ELIMINAR}/${id}`, extraHeaders: { token: token } });;
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default eliminarPersonaService;